import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "FacebookCircle",
  "use": "FacebookCircle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"FacebookCircle\"><circle cx=\"16\" cy=\"16\" r=\"14\" fill=\"currentColor\" /><path d=\"M13.4 13.3h-2V16h2v8.2h3.4V16h2.5l.2-2.7h-2.7v-1.1c0-.6.1-.9.8-.9h2V7.8H17c-2.4 0-3.5 1.1-3.5 3.1v2.4z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol